import React from 'react';
import { Icon } from './Icon.js';
export const IconImage = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 18L17 13H16L9.5 21", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M12 9.5C12 10.8807 10.8807 12 9.5 12C8.11929 12 7 10.8807 7 9.5C7 8.11929 8.11929 7 9.5 7C10.8807 7 12 8.11929 12 9.5Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M3 21H21V3H3V21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconImage.js.map